import gql from 'graphql-tag';

export const LOGISTIC_FORWARDER = gql`
  fragment provider on Provider {
    value
    id
  }
`;
